<script setup lang="ts">
const OPTIONS: readonly number[] = [10000, 15000, 20000, 25000, 30000] as const

defineProps<{
  modelValue: number
}>()

const emit = defineEmits<{
  'update:modelValue': [value: number]
}>()

function onChange(event: Event) {
  const next = Number((event.target as HTMLSelectElement).value)
  emit('update:modelValue', next)
}

const numberFormatter = new Intl.NumberFormat('da-DK')
function formatKm(km: number): string {
  return `${numberFormatter.format(km)} km`
}
</script>

<template>
  <div class="annual-km-select">
    <label class="annual-km-select__label" for="annual-km-select-field">Km pr. år</label>
    <div class="annual-km-select__field">
      <select
        id="annual-km-select-field"
        class="annual-km-select__input"
        :value="modelValue"
        aria-label="Vælg kørte kilometer pr. år"
        @change="onChange"
      >
        <option v-for="option in OPTIONS" :key="option" :value="option">
          {{ formatKm(option) }}
        </option>
      </select>
      <svg
        class="annual-km-select__chevron"
        width="12"
        height="12"
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M4 6l4 4 4-4"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.annual-km-select {
  display: flex;
  flex-direction: column;
  gap: space(2);

  &__label {
    font-weight: $font-weight-semibold;
    color: color('ink');
    font-size: $font-size-sm;
  }

  &__field {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: fit-content;
    padding: space(1) space(8) space(1) space(3);
    background: color('white');
    border: 1px solid color('background-medium');
    border-radius: $radius-md;
    transition: border-color $duration-base $easing-standard;

    &:focus-within {
      border-color: color('accent');
      box-shadow: 0 0 0 3px rgb(0, 176, 62, 0.15);
    }
  }

  &__input {
    appearance: none;
    padding: space(1) 0;
    background: transparent;
    border: none;
    outline: none;
    font-family: inherit;
    font-size: $font-size-md;
    font-weight: $font-weight-bold;
    color: color('primary');
    min-width: 6rem;
    cursor: pointer;
  }

  &__chevron {
    position: absolute;
    right: space(3);
    color: color('ink-light');
    pointer-events: none;
  }
}
</style>
